import React, { useEffect, useState } from 'react'

const HeaderStatusInfo = (props) => {
    const id = props.id
    const type = props.type
    const status = props.status
    
    if (!id || id === 0) {
        return (<span/>)
    }

    const version = type === 'Customer Document'
                  ? 'Version'
                  : 'Issue'
    
    const map = {
        Reserved: (
            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                <i className="fa fa-circle-o" aria-hidden="true"></i> &nbsp;
                <b>Reserved.</b> This {type} Reference is allocated for use.
            </div>),
        Filed: (
            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                <i className="fa fa-check-circle" aria-hidden="true"></i> &nbsp;
                <b>Filed.</b> This is the most recent {version} of this {type}.
            </div>),
        Withdrawn: (
            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                <i className="fa fa-ban" aria-hidden="true"></i> &nbsp;
                <b>Withdrawn.</b> This {type} Reference is not available for use.
            </div>
        ),
        Superseded: (
            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> &nbsp;
                <b>Superseded.</b> This is not the latest {version} of this {type}.
            </div>
        ),
        Live: (
            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                <i className="fa fa-check-circle" aria-hidden="true"></i> &nbsp;
                <b>Issued.</b> This is the most recent {version} of this {type}.
            </div>
        )
    }
    return map[status] || (<span/>)
}
export default HeaderStatusInfo
